export default __webpack_public_path__ + "static/media/banner-ordinary-coverage-mobile.3b93a8aa.png";